"use strict";

exports.__esModule = true;
exports.LocaleProvider = exports.LocaleContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _options = require("./options");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* global KEYTRADE_LOCALIZATION_INTL_FOLDER */

var flattenMessages = function flattenMessages(nestedMessages, prefix) {
  if (prefix === void 0) {
    prefix = '';
  }
  if (nestedMessages === null) {
    return {};
  }
  return Object.keys(nestedMessages).reduce(function (messages, key) {
    var value = nestedMessages[key];
    var prefixedKey = prefix ? prefix + "." + key : key;
    if (typeof value === 'string') {
      var _Object$assign;
      Object.assign(messages, (_Object$assign = {}, _Object$assign[prefixedKey] = value, _Object$assign));
    } else {
      Object.assign(messages, flattenMessages(value, prefixedKey));
    }
    return messages;
  }, {});
};
var LocaleContext = exports.LocaleContext = /*#__PURE__*/(0, _react.createContext)(_options.defaultLang);
var LocaleProvider = exports.LocaleProvider = function LocaleProvider(_ref) {
  var children = _ref.children,
    _ref$pageContext$loca = _ref.pageContext.locale,
    locale = _ref$pageContext$loca === void 0 ? _options.defaultLang : _ref$pageContext$loca;
  var _useState = (0, _react.useState)(locale),
    currentLocale = _useState[0],
    setCurrentLocale = _useState[1];
  var message = require(KEYTRADE_LOCALIZATION_INTL_FOLDER + "/" + currentLocale + ".json");
  var flattenedMessage = flattenMessages(message);
  return /*#__PURE__*/_react.default.createElement(LocaleContext.Provider, {
    value: {
      locale: currentLocale,
      changeLocale: function changeLocale(locale) {
        setCurrentLocale(locale);
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.IntlProvider, {
    locale: locale,
    defaultLocale: _options.defaultLang,
    key: locale,
    messages: flattenedMessage
  }, children));
};